<template>
  <auth>
    <div
      v-if="is_loaded"
      class="auth"
    >
      <h4>Enter your personal information</h4>
      <div v-html="$error.handle(error)" />
      <form
        class="login"
        @submit.prevent="submit"
      >
        <div class="form-group">
          <label for="first_name">First Name</label>
          <input
            id="first_name"
            v-model="personal.firstname"
            type="text"
            class="form-control"
          >
        </div>
        <div class="form-group">
          <label>Middle Name</label>
          <input
            v-model="personal.middlename"
            type="text"
            class="form-control"
          >
        </div>
        <div class="form-group">
          <label>Last Name</label>
          <input
            v-model="personal.lastname"
            type="text"
            class="form-control"
          >
        </div>
        <div class="form-group">
          <label>ID Number</label>
          <input
            v-model="personal.id_number"
            type="text"
            class="form-control"
          >
        </div>

        <div class="form-group">
          <label>Citizenship</label>
          <select
            v-model="personal.citizenship"
            class="form-control"
          >
            <option value="kenyan">
              Kenyan
            </option>
            <option value="foreigner">
              Foreigner
            </option>
          </select>
        </div>
        <div class="form-group">
          <button class="btn btn-primary">
            Validate
          </button>
        </div>
      </form>
    </div>
    <loading v-else />
  </auth>
</template>

<script>

import Auth from "@/components/Auth.vue";

export default {
  components: {
    Auth
  },
  data() {
    return {
      personal: {
        firstname: '',
        middlename: '',
        lastname: '',
        id_number: '',
        citizenship: 'kenyan'
      },
      error: '',
      is_loaded: true
    }
  },
  computed: {
    user() {
      return this.$store.getters.getAuthUser;
    },
  },
  watch: {
    'user': {
      handler(oldval, newval) {
        if (oldval !== newval) {
          this.initiate();
        }
      }
    }
  },
  mounted() {
    this.initiate();
  },
  methods: {
    submit() {
      this.is_loaded = false;
      this.$axios.post('/api/v1/verify/personal', this.personal).then(() => {
        this.is_loaded = true;
        this.$store.dispatch('initialize').then(() => {
          this.$router.replace({name: 'verify.phone'});
        });
      }).catch(error => {
        this.error = error.response;
      }).finally(() => {
        this.is_loaded = true;
      })
    },
    initiate() {

      if (!this.user.email) {
        this.$store.dispatch('initialize');
      }

      if (this.user.requires_password_change) {
        this.$router.replace({name: 'set-password'});
        return;
      }
      if (this.user.verified_phone) {
        this.$router.replace({name: 'dashboard'});
        return;
      }

      if (!this.user.verified_phone && this.user.id_number !== null) {
        this.$router.replace({name: 'verify.phone'});
      }
    },
  }
}
</script>
